<template>
  <div class="survey-message-editor">
    <!-- Type tabs -->
    <div class="message-type-tabs">
      <button
        class="message-type-tab"
        :class="{ active: !showBoss }"
        @click="switchSection(false)"
      >
        Colaborador
      </button>
      <button
        class="message-type-tab"
        :class="{ active: showBoss }"
        @click="switchSection(true)"
      >
        Líder
      </button>
    </div>

    <div class="editor-layout">
      <!-- Editor panel -->
      <div class="editor-panel">
        <div class="panel-header">
          <span class="panel-title">Editor</span>
          <span v-if="hasCustomMessage" class="status-badge custom">
            <i class="material-icons">check_circle</i>
            Personalizado
          </span>
          <span v-else class="status-badge default">
            <i class="material-icons">info</i>
            Por defecto
          </span>
        </div>

        <div class="panel-body">
          <!-- Collaborator form -->
          <template v-if="!showBoss">
            <div class="form-group">
              <label class="form-label">Título principal</label>
              <input
                v-model="data.colaborador.title"
                :class="{ 'has-error': errors.colaborador.title.message }"
                class="input"
                type="text"
                placeholder="Título que verá el colaborador"
              />
              <span v-if="errors.colaborador.title.message" class="error-message">
                {{ errors.colaborador.title.message }}
              </span>
            </div>

            <div class="form-group">
              <label class="form-label">Mensaje de bienvenida</label>
              <textarea
                v-model="data.colaborador.cuerpo"
                :class="{ 'has-error': errors.colaborador.cuerpo.message }"
                class="textarea"
                placeholder="Escribe el mensaje que verá el colaborador al iniciar la encuesta..."
                rows="10"
              ></textarea>
              <span v-if="errors.colaborador.cuerpo.message" class="error-message">
                {{ errors.colaborador.cuerpo.message }}
              </span>
            </div>
          </template>

          <!-- Leader form -->
          <template v-if="showBoss">
            <div class="form-group">
              <label class="form-label">Título principal</label>
              <input
                v-model="data.lider.title"
                :class="{ 'has-error': errors.lider.title.message }"
                class="input"
                type="text"
                placeholder="Título que verá el líder"
              />
              <span v-if="errors.lider.title.message" class="error-message">
                {{ errors.lider.title.message }}
              </span>
            </div>

            <div class="form-group">
              <label class="form-label">Mensaje de bienvenida</label>
              <textarea
                v-model="data.lider.cuerpo"
                :class="{ 'has-error': errors.lider.cuerpo.message }"
                class="textarea"
                placeholder="Escribe el mensaje que verá el líder al iniciar la encuesta..."
                rows="10"
              ></textarea>
              <span v-if="errors.lider.cuerpo.message" class="error-message">
                {{ errors.lider.cuerpo.message }}
              </span>
            </div>
          </template>

          <!-- Actions -->
          <div class="button-group">
            <button
              class="button is-dark"
              :class="{ 'is-loading': loading }"
              @click="saveData"
            >
              Guardar
            </button>
            <button class="button" @click="deleteMessage">
              Restaurar predeterminado
            </button>
          </div>
        </div>
      </div>

      <!-- Preview panel -->
      <div class="preview-panel">
        <div class="panel-header">
          <span class="panel-title">Vista previa</span>
        </div>
        <div class="panel-body preview-body">
          <div class="survey-preview-frame">
            <div class="survey-preview">
              <div class="survey-card">
                <h1 class="survey-title">{{ previewTitle }}</h1>
                <div class="survey-content">{{ previewBody }}</div>
              </div>
              <div class="preview-badge">
                <i class="material-icons">visibility</i>
                Así se verá en la encuesta
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiServices from '@/services/yungol-services'
import json from '../infoEncuesta.json'

export default {
  data() {
    return {
      showBoss: false,
      errors: {
        lider: { title: {}, cuerpo: {} },
        colaborador: { title: {}, cuerpo: {} }
      },
      dataDefault: json,
      loading: false
    }
  },
  props: {
    proceso: Object,
    data: Object,
    tokenUser: Object
  },
  computed: {
    hasCustomMessage() {
      if (this.showBoss) {
        return this.data.lider.title || this.data.lider.cuerpo
      }
      return this.data.colaborador.title || this.data.colaborador.cuerpo
    },
    previewTitle() {
      if (this.showBoss) {
        return this.data.lider.title || this.dataDefault.title.lider + ' ' + this.tokenUser.name
      }
      return this.data.colaborador.title || this.dataDefault.title.colaboradores
    },
    previewBody() {
      if (this.showBoss) {
        return this.data.lider.cuerpo || this.dataDefault.welcome.lider.Lider
      }
      return this.data.colaborador.cuerpo || this.dataDefault.welcome.colaboradores.Colaborador
    }
  },
  methods: {
    switchSection(d) {
      this.showBoss = d
      this.clearErrors()
    },
    async saveData() {
      if (this.validateForm()) {
        try {
          this.loading = true
          const result = await apiServices.post(`createinfo/${this.proceso._id}`, this.data)

          if (result.data) {
            await this.$swal({
              text: 'Se guardó correctamente el mensaje.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1700
            })
            this.loading = false
            this.clearErrors()
          }
        } catch (error) {
          console.log(error)
          await this.$swal({
            text: 'Error al guardar el mensaje.',
            icon: 'error',
            showConfirmButton: false,
            timer: 1700
          })
          this.loading = false
          this.clearErrors()
        }
      }
    },
    async deleteMessage() {
      const config = {
        title: '¿Restaurar predeterminado?',
        text: 'Se eliminará la personalización y se usará el mensaje por defecto.',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#de5b5b',
        confirmButtonText: 'Sí, restaurar',
        cancelButtonText: 'Cancelar'
      }
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.clearErrors()
            const data = {
              lider: {
                lider: { title: '', cuerpo: '' }
              },
              colaborador: {
                colaborador: { title: '', cuerpo: '' }
              }
            }
            const type = this.showBoss ? 'lider' : 'colaborador'
            const resultData = await apiServices.post(`createinfo/${this.proceso._id}`, data[type])
            if (resultData) {
              this.$emit('getData')
              await this.$swal({
                text: 'Mensaje restaurado al valor por defecto.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1700
              })
            }
          } catch (err) {
            await this.$swal({
              text: 'Error al restaurar el mensaje.',
              icon: 'error',
              showConfirmButton: false,
              timer: 1700
            })
            console.log(err)
          }
        }
      })
    },
    validateForm() {
      this.errors = {
        lider: { title: {}, cuerpo: {} },
        colaborador: { title: {}, cuerpo: {} }
      }

      const data = this.data
      const type = this.showBoss ? 'lider' : 'colaborador'
      let valid = true

      if (!data[type].title || data[type].title.trim() === '') {
        this.errors[type].title.message = 'El título es requerido.'
        valid = false
      }

      if (!data[type].cuerpo || data[type].cuerpo.trim() === '') {
        this.errors[type].cuerpo.message = 'El cuerpo es requerido.'
        valid = false
      }

      return valid
    },
    clearErrors() {
      this.errors = {
        lider: { title: {}, cuerpo: {} },
        colaborador: { title: {}, cuerpo: {} }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.survey-message-editor {
  width: 100%;
}

.message-type-tabs {
  display: flex;
  gap: 4px;
  background: #f5f5f5;
  padding: 4px;
  border-radius: 6px;
  margin-bottom: 20px;
}

.message-type-tab {
  flex: 1;
  padding: 10px 16px;
  border: none;
  background: transparent;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.15s ease;
  text-align: center;

  &:hover {
    color: #333;
    background: #fff;
  }

  &.active {
    background: #363636;
    color: #fff;
    font-weight: 500;
  }
}

.editor-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
}

.editor-panel,
.preview-panel {
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.panel-header {
  padding: 14px 18px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;

  .material-icons {
    font-size: 14px;
  }

  &.custom {
    background: rgba(5, 150, 105, 0.1);
    color: #059669;
  }

  &.default {
    background: #f5f5f5;
    color: #999;
  }
}

.panel-body {
  padding: 18px;
  flex: 1;
}

.preview-body {
  padding: 0;
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 18px;
}

.form-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #666;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.input,
.textarea {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.15s ease;

  &:focus {
    border-color: #5e2ca5;
    outline: none;
  }

  &.has-error {
    border-color: #f14668;
  }
}

.textarea {
  resize: none;
  line-height: 1.6;
}

.error-message {
  display: block;
  color: #f14668;
  font-size: 12px;
  margin-top: 4px;
}

.button-group {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  padding-top: 18px;
  border-top: 1px solid #e5e5e5;
}

// Preview styles
.survey-preview-frame {
  background: #e8e8e8;
  padding: 20px;
  flex: 1;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.survey-preview {
  max-width: 440px;
  width: 100%;
}

.survey-card {
  background: #fff;
  border-radius: 8px;
  padding: 32px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.survey-title {
  font-size: 18px;
  font-weight: 600;
  color: #363636;
  margin: 0 0 16px 0;
  line-height: 1.4;
}

.survey-content {
  font-size: 14px;
  line-height: 1.7;
  color: #555;
  white-space: pre-line;
}

.preview-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 11px;
  color: #999;
  margin-top: 16px;

  .material-icons {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/Ajustes/MessageSurvey.vue